import React, { useEffect, useState } from "react";
import "./header.scss";

import CoinCard from "../coins-card/coins-card";
import Image from "../../components/image/image";
import CoinImg from "../../assets/coin.png";
import ExitButton from "../../assets/exit.png";
import backButton from "../../assets/backward.png";
import SearchIcon from "../../assets/searchIcon.svg";
import BackIcon from "../../assets/backIcon.svg";

const Header = ({
  onClick,
  coin,
  label,
  location,
  city,
  locationChange,
  searchIcon,
  isOutletList,
  exitButton
}) => {
  const [currentCity, setCurrentCity] = useState(city || sessionStorage.getItem("city"));
  const [currentLocality, setCurrentLocality] = useState(location || sessionStorage.getItem("locality"));

  useEffect(() => {
    if (!currentCity) {
      const storedCity = sessionStorage.getItem("city");
      if (storedCity) {
        setCurrentCity(storedCity);
      }
    }

    if (!currentLocality) {
      const storedLocality = sessionStorage.getItem("locality");
      if (storedLocality) {
        setCurrentLocality(storedLocality);
      }
    }
  }, [currentCity, currentLocality]);

  // const cityDisplay = currentCity || "";
  const cityDisplay = currentCity && currentCity.includes(",") ? "Multiple Cities" : currentCity || "";
  const locationDisplay = currentLocality || "Select Location";

  return (
    <div className="header-section">
      <div className="back-btn-section">
        <Image src={exitButton?ExitButton:backButton} alt="" imgStyle="back-img" onClick={onClick} />
        <div className="rest-detail">
          {label ? (
            <div>
              {label && 
                <div className="rest-name">{label}</div>
              }
              {location && 
                <span className="location">{location}</span>
              }
            </div>
          ) : (
            <div className="search-section" onClick={locationChange}>
              <div className="search-text">
                <div className="location-text">
                  {/* {cityDisplay === ""?`${locationDisplay}`:`${locationDisplay}, ${cityDisplay}`} */}
                  {cityDisplay === ""?`Select Location`:`${cityDisplay}`}
                </div>
                <img
                  src={BackIcon}
                  className="down-arrow"
                  alt=""
                  onClick={locationChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {
        coin && coin!==0?
        <div className="wallet-section">
          <CoinCard imgSrc={CoinImg} cardText={coin} />
        </div>
        :null
      }
    </div>
  );
};

export default Header;
